export enum RecipeComponentStates {
    Delete = 3,
    Update = 2,
    Insert = 4,
    Default = 1
}



// WEBPACK FOOTER //
// ./src/app/shared/dictionaries/RecipeComponentStates.ts